export const SMSEnabledMapping = {
    Enabled: 1,
    Default: null,
    Disabled: 0,
};
export const SMSEnabledMappingAsString = {
    Enabled: "1",
    Default: "null",
    Disabled: "0",
};
export const SMSEnabledStringValueToValue = (stringValue) => {
    switch (stringValue) {
        case "1":
            return 1;
        case "0":
            return 0;
        case "null":
        default:
            return null;
    }
};
